// extracted by mini-css-extract-plugin
module.exports = {"addresses":"ValidatorAddresses_addresses__2wuW1","item":"ValidatorAddresses_item__3B_VD"};